
/*function bindSizeToPostPreview() {
  const aspectRatio = 0.625; // 8:5 Aspect Ratio
  const imageContainer = jQuery( ".aspect-ratio-container" );
  
  imageContainer.toArray().forEach(function(element) {
    const imageWrapper = jQuery(element);

    const url = imageWrapper.data("click-url");
    if(url) {
      imageWrapper.click(function() {
        window.open(url, "_self");
        return false;
      });
    }
 
    const innerImageWrapper = imageWrapper.find("div.aspect-ratio-container-inner");

    const paddingTopPaddingValue = (aspectRatio * 100) + "%";
    innerImageWrapper.css("padding-top", paddingTopPaddingValue);
    const image = imageWrapper.children().find('img').first();
    const imageIsPortrait = image.width() < image.height();
    if(imageIsPortrait) {
      const height = imageContainer.width() * aspectRatio + "px";
      imageContainer.css("min-height", height);

      innerImageWrapper.css({
        "padding-top": "0",
        "min-height": height,
        "height": "100%"
      });
    }

    const windowWidth = jQuery(window).width();
    if(windowWidth < 768) {
      const imageHeight = windowWidth * aspectRatio;
      imageWrapper.height(imageHeight);
      image.height(imageHeight);
    }
    else {
      imageWrapper.height('');
      image.height('100%');
    }
  });
}

jQuery( window ).resize(function() {
  bindSizeToPostPreview();
});

bindSizeToPostPreview();*/

function ensurePostPreviewSizing() {
  const aspectRatio = 0.625; // 8:5 Aspect Ratio
  const imageContainer = jQuery( ".aspect-ratio-container" );
  
  imageContainer.toArray().forEach(function(element) {
    const container = jQuery(element);
    const containerWidth = container.width();
    const containerHeight = containerWidth * aspectRatio;
    container.css("min-height", containerHeight + "px");

    const url = container.data("click-url");
    if(url) {
      container.click(function() {
        window.open(url, "_self");
        return false;
      });
    }
  });
}

jQuery( window ).resize(function() {
  ensurePostPreviewSizing();
})

ensurePostPreviewSizing();